import {
  CloseIcon,
  FaceBIcon,
  HeaderContainer,
  HeaderItem,
  HeaderList,
  ImgLogo,
  InstIcon,
  LeftConatiner,
  Link,
  LogoLink,
  Menu,
  MenuConteiner,
  MenuIcon,
  MobileMenu,
  NavItem,
  NavItemIcons,
  NavSpan,
  Navigation,
  PhoneIcon,
  RightContainer,
  StyledLink,
  TelegramIcon,
} from './Header.styled';
import logo from '../../Images/AlltentaWhiteLogo.png';
import { useEffect, useState } from 'react';

const Header = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [menuClick, setMenuClick] = useState(false);
  const handleMouseEnter = () => {
    setIsMenuVisible(true);
  };
  const handleMouseLeave = () => {
    setIsMenuVisible(false);
  };
  const handleOpenButton = () => {
    setMenuClick(true);
  };
  const handleCloseButton = () => {
    setMenuClick(false);
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <HeaderContainer>
      <LeftConatiner>
        <LogoLink to="/">
          <ImgLogo src={logo} alt="Логотип Alltenta - ПВХ штори та тенти" />
        </LogoLink>
      </LeftConatiner>
      {isMobile ? (
        menuClick ? (
          <CloseIcon
            onClick={handleCloseButton}
            id="close-menu-button"
            aria-label="Закрити меню"
          />
        ) : (
          <MenuIcon
            onClick={handleOpenButton}
            id="open-menu-button"
            aria-label="Відкрити меню"
          />
        )
      ) : (
        <></>
      )}
      <RightContainer>
        <Navigation>
          <NavItem>
            <Link to="/Alltenta" duration={500} offset={-70}>
              <NavSpan>Про Alltenta</NavSpan>
            </Link>
          </NavItem>
          <NavItem>
            <MenuConteiner
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link duration={500} offset={-70}>
                Каталог товарів
              </Link>
              {isMenuVisible ? (
                <Menu>
                  <HeaderList>
                    <HeaderItem>
                      <Link to="/ProductList/М'які вікна">М'які вікна</Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Штори ПВХ">Штори ПВХ</Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Тенти для авто та ін.">
                        Тенти для авто та ін.
                      </Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Накриття ПВХ">Накриття ПВХ</Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Чаші для басейнів">
                        Чаші для басейнів
                      </Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Москітні сітки">
                        Москітні сітки
                      </Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Стрічкові ПВХ завіси">
                        Стрічкові ПВХ завіси
                      </Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Фурнітура">Фурнітура</Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Захисне покриття">
                        Захисне покриття
                      </Link>
                    </HeaderItem>
                    <HeaderItem>
                      <Link to="/ProductList/Бесідки">Бесідки</Link>
                    </HeaderItem>
                  </HeaderList>
                </Menu>
              ) : (
                <></>
              )}
            </MenuConteiner>
          </NavItem>
          <NavItem>
            <Link to="/Contact" duration={500} offset={-70}>
              <NavSpan>Контакти</NavSpan>
            </Link>
          </NavItem>
          <NavItem>
            <Link to="/Dealer" duration={500} offset={-70}>
              <NavSpan>Для дилерів</NavSpan>
            </Link>
          </NavItem>
          <NavItem>
            <Link to="/Blog" duration={500} offset={-70}>
              <NavSpan>Блог</NavSpan>
            </Link>
          </NavItem>
          <NavItem>
            <StyledLink href="https://www.instagram.com/alltenta_ua/">
              <InstIcon />
            </StyledLink>
          </NavItem>
          <NavItem>
            {' '}
            <StyledLink href="https://t.me/AlltentaBot">
              <TelegramIcon />
            </StyledLink>
          </NavItem>
          <NavItem>
            <StyledLink href="https://www.facebook.com/profile.php?id=61563428046087">
              <FaceBIcon />
            </StyledLink>
          </NavItem>
          <NavItem>
            <StyledLink href="viber://add?number=380930332929">
              <PhoneIcon />
            </StyledLink>
          </NavItem>
          <NavItem>
            <StyledLink href="tel:+38097 033 29 29">
              +380 97 033-29-29
            </StyledLink>
            <StyledLink href="tel:+38093 033 29 29">
              +380 93 033-29-29
            </StyledLink>
          </NavItem>
        </Navigation>
      </RightContainer>
      {isMobile && menuClick && (
        <MobileMenu>
          <Navigation>
            <NavItem>
              <Link
                to="/Alltenta"
                onClick={handleCloseButton}
                duration={500}
                offset={-70}
              >
                <NavSpan>Про Altenta</NavSpan>
              </Link>
            </NavItem>
            <NavItem>
              <MenuConteiner
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link duration={500} offset={-70}>
                  Каталог товарів
                </Link>
                {isMenuVisible ? (
                  <Menu>
                    <HeaderList>
                      <HeaderItem>
                        <Link to="/ProductList/М'які вікна">М'які вікна</Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Штори ПВХ">Штори ПВХ</Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Тенти для авто та ін.">
                          Тенти для авто та ін.
                        </Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Накриття ПВХ">Накриття ПВХ</Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Чаші для басейнів">
                          Чаші для басейнів
                        </Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Product/3">Москітні сітки</Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Product/2">
                          Стрічкові ПВХ завіси
                        </Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Фурнітура">Фурнітура</Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Захисне покриття">
                          Захисне покриття
                        </Link>
                      </HeaderItem>
                      <HeaderItem>
                        <Link to="/ProductList/Бесідки">Бесідки</Link>
                      </HeaderItem>
                    </HeaderList>
                  </Menu>
                ) : (
                  <></>
                )}
              </MenuConteiner>
            </NavItem>
            <NavItem>
              <Link
                to="/Contact"
                onClick={handleCloseButton}
                duration={500}
                offset={-70}
              >
                <NavSpan>Контакти</NavSpan>
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/Dealer" duration={500} offset={-70}>
                <NavSpan>Для дилерів</NavSpan>
              </Link>
            </NavItem>
            <NavItem>
              <Link
                to="/Blog"
                onClick={handleCloseButton}
                duration={500}
                offset={-70}
              >
                <NavSpan>Блог</NavSpan>
              </Link>
            </NavItem>
            <NavItem>
              <StyledLink href="tel:+38097 033 29 29">
                +380 97 033-29-29
              </StyledLink>
              <StyledLink href="tel:+38093 033 29 29">
                +380 93 033-29-29
              </StyledLink>
            </NavItem>
            <NavItemIcons>
              <StyledLink href="https://www.instagram.com/alltenta_ua/">
                <InstIcon />
              </StyledLink>
              <StyledLink href="https://www.facebook.com/profile.php?id=61563428046087">
                <FaceBIcon />
              </StyledLink>
              <StyledLink href="https://t.me/AlltentaBot">
                <TelegramIcon />
              </StyledLink>
              <StyledLink href="viber://add?number=380930332929">
                <PhoneIcon />
              </StyledLink>
            </NavItemIcons>
          </Navigation>
        </MobileMenu>
      )}
    </HeaderContainer>
  );
};

export default Header;
